/**
 * bpmnPlaceholder - Bloco "vazio" criado pelo "+" de dentro dos gateways
 *
 * Como `workflow_edges.to_node_id` é obrigatório no banco, uma saída nova
 * precisa apontar para algum bloco. Criamos então um bloco temporário
 * (placeholder) que o usuário resolve clicando no "+" que já existe no meio da
 * linha: ao escolher o tipo, o MESMO bloco é convertido (não é criado outro).
 *
 * @version 1.0.0
 * RELEASE: 2026-09-04 v1.0.0 - Criação inicial (saídas criadas pelo "+" do bloco)
 */

import type { WorkflowEditorNode } from '@/hooks/useWorkflowDesigner';

/** Chave gravada em `workflow_nodes.config` para marcar o bloco temporário */
export const CHAVE_PLACEHOLDER = '__placeholder';

/** Rótulo exibido no mapa enquanto o bloco não é escolhido */
export const ROTULO_PLACEHOLDER = 'Escolha o próximo bloco';

/** Configuração inicial de um bloco temporário */
export const CONFIG_PLACEHOLDER: Record<string, unknown> = { [CHAVE_PLACEHOLDER]: true };

/** Diz se o bloco ainda é um destino temporário (aguardando escolha do tipo) */
export function ehPlaceholder(node?: WorkflowEditorNode | null): boolean {
  return !!node && node.config?.[CHAVE_PLACEHOLDER] === true;
}
